<mat-card appearance="raised">
  <mat-card-header>
    <mat-card-title>Bank linking info</mat-card-title>
  </mat-card-header>
  <mat-card-content class="mat-card-content-lg no-bottom-padding">
    <ifc-horizontal-list [items]="listItems">
      <ng-template horizontalListCustomTemplate="linkStatusValue">
        <ifb-bank-account-link-status-icon-chip class="status"
                                                [status]="entity?.bankLinkStatus">
        </ifb-bank-account-link-status-icon-chip>
      </ng-template>
      <ng-template horizontalListCustomTemplate="verificationStatusValue">
        <ifb-bank-account-verification-icon-chip class="status"
                                                 [status]="entity?.isVerified ? VerificationStatus.Verified : VerificationStatus.Unverified">
        </ifb-bank-account-verification-icon-chip>
      </ng-template>
    </ifc-horizontal-list>
  </mat-card-content>
</mat-card>
